// =======================================================
// Google Translate - GTranslate.io
// =======================================================
window.addEventListener("load", (event) => {
    // console.log("page is fully loaded");

    // Variable
    const tools = document.querySelector('#js-tools')
    const toolsTranslate = tools.querySelector('#js-toolsTranslate')
    const translateBtn = tools.querySelector('#js-translateBtn')
    const translateClose = tools.querySelector('#js-translateBtn--close')
    const translateWrapper = tools.querySelector('#js-translateWrapper')
    const translatelinks = tools.querySelectorAll('.tools__translate a.glink')
    const translateGoogle = tools.querySelector('#google_translate_element2')

    if (translateBtn) {

        // Move close button at the end
        translateWrapper.insertBefore(translateClose, translateGoogle)

        !!translateBtn && translateBtn.addEventListener('click', function () {
            translateWrapper.classList.toggle('js-open');
        })

        translatelinks.forEach(function (translatelink) {
            translatelink.addEventListener('click', function () {
                this.parentElement.classList.remove('js-open')
            })
        })

        translateClose.addEventListener('click', function () {
            translateWrapper.classList.remove('js-open')
        })

        document.addEventListener("mouseup", function (event) {
            if (!toolsTranslate.contains(event.target)) {
                translateWrapper.classList.remove('js-open')
            }
        })
    }

})


// =======================================================
// Google Translate -- OLD
// =======================================================
// Function eventFire
// function eventFire(el, etype){
//     if (el.fireEvent) {
//         el.fireEvent('on' + etype);
//     } else {
//         let evObj = document.createEvent('Events');
//         evObj.initEvent(etype, true, false);
//         el.dispatchEvent(evObj);
//     }
// }
// // Variable
// const translateBtn = tools.querySelector('#js-toolTranslate');

// // Event click
// if (translateBtn) {
//     !!translateBtn && translateBtn.addEventListener('click', function() {
//         let googleGadget = document.querySelector('#google_translate_element .skiptranslate .goog-te-gadget-simple');

//         eventFire(googleGadget, 'click');

//         return false;
//     })
// }